export default[
  {
    path: '/dataList/abnormalAttendance',
    component: resolve => require(['../page.vue'], resolve),
    meta: {
        title: '打卡异常',
        authLogin: true
    }
  }
]